<script lang="ts">
  import ImportList from '../../lib/components/imports/ImportList.svelte';
  import { t } from '../../lib/i18n/index.ts';

  // Imports brings history from Google Timeline, a Google Takeout archive,
  // GPX, and GeoJSON into the member's own long-term timeline (005 FR-065,
  // 005 FR-067, 005 FR-068, 005 FR-069, 005 FR-070, 005 FR-071). Nothing
  // imported reaches the groups' maps, day history, or place alerts. It
  // lists the imports that read location history (005 FR-076).
</script>

<div class="flex-1 overflow-y-auto p-6">
  <div class="max-w-3xl mx-auto space-y-4">
    <ImportList title={t('timelineImportTitle')} part="location">
      <p>{t('timelineImportAbout')}</p>
      <p>{t('timelineImportFit')}</p>
    </ImportList>
  </div>
</div>
